var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tasks-complete-invoke',{attrs:{"params":{
        task: _vm.task.uuid
    }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var error = ref.error;
    var invoke = ref.invoke;
return [_c('div',{staticClass:"w-6 h-6"},[_c('input-checkbox',{staticClass:"block",attrs:{"is-interactive":_vm.task.can_complete},on:{"toggle":invoke},model:{value:(_vm.is_checked),callback:function ($$v) {_vm.is_checked=$$v},expression:"is_checked"}}),_vm._v(" "),(error && _vm.$error.is(error, { exclude: [422] }))?_c('error-modal',{attrs:{"error":error}}):_vm._e()],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }